import {
  FETCH_PATIENT_DOCTORS,
  FETCH_PATIENT_DOCTORS_SUCCESS,
  FETCH_PATIENT_BY_ID,
  FETCH_PATIENT_BY_ID_SUCCESS,
  ON_PATIENT_SAVE_IMAGES,
  UPDATE_PATIENT_IMAGES,
  ON_PATIENT_DELETE_IMAGES,
  PATIENT_DELETE_IMAGES_SUCCESS,
  SHOW_SINGLE_PATIENT_LOADER,
  SHOW_SINGLE_PATIENT_IMAGE_LOADER,
  SHOW_SINGLE_PATIENT_MESSAGE,
  HIDE_SINGLE_PATIENT_LOADER,
  FETCH_PATIENT_HISTORY,
  FETCH_PATIENT_HISTORY_SUCCESS,
  ADD_NEW_PAID,
  SHOW_SINGLE_PATIENT_HISTORY_LOADER,
  ON_UPDATE_PATIENT,
  ON_UPDATE_PATIENT_SUCCESS,
  ON_DELETE_PAYMENT,
  DELETE_PATIENT_HISTORY,
  ON_SAVE_NEW_INTERVENTIONS,
  SHOW_SAVING_INTERVENTIONS_BTN_LOADER,
  SAVE_INTERVENTIONS_SUCCESS
} from 'constants/ActionTypes';

export const fetchDoctors = () => {
  return {
    type: FETCH_PATIENT_DOCTORS
  };
};
export const fetchDoctorsSuccess = (doctors) => {
  return {
    type: FETCH_PATIENT_DOCTORS_SUCCESS,
    payload: doctors
  };
};
export const fetchPatientById = (patientId) => {
  return {
    type: FETCH_PATIENT_BY_ID,
    payload: { patientId }
  };
};
export const fetchPatientByIdSuccess = (patient) => {
  return {
    type: FETCH_PATIENT_BY_ID_SUCCESS,
    payload: patient
  };
};
export const onSaveImages = (images) => {
  return {
    type: ON_PATIENT_SAVE_IMAGES,
    payload: images
  };
};
export const saveImagesSuccess = (images) => {
  return {
    type: UPDATE_PATIENT_IMAGES,
    payload: images
  };
};
export const onDeleteImage = (images) => {
  return {
    type: ON_PATIENT_DELETE_IMAGES,
    payload: images
  };
};
export const deleteImagesSuccess = (images) => {
  return {
    type: PATIENT_DELETE_IMAGES_SUCCESS,
    payload: images
  };
};
export const showSinglePatientLoader = () => {
  return {
    type: SHOW_SINGLE_PATIENT_LOADER
  };
};
export const showPatientImageLoader = () => {
  return {
    type: SHOW_SINGLE_PATIENT_IMAGE_LOADER
  };
};
export const showSinglePatientMessage = (message, messageStatus = false) => {
  return {
    type: SHOW_SINGLE_PATIENT_MESSAGE,
    payload: { message, messageStatus }
  };
};
export const hideSinglePatientLoader = () => {
  return {
    type: HIDE_SINGLE_PATIENT_LOADER
  };
};
export const fetchPatientHistory = (patientId) => {
  return {
    type: FETCH_PATIENT_HISTORY,
    payload: { patientId }
  };
};
export const fetchPatientHistorySuccess = (history) => {
  return {
    type: FETCH_PATIENT_HISTORY_SUCCESS,
    payload: history
  };
};
export const addNewPaid = (data) => {
  return {
    type: ADD_NEW_PAID,
    payload: data
  };
};
export const showSinglePatientHistoryLoader = () => {
  return {
    type: SHOW_SINGLE_PATIENT_HISTORY_LOADER
  };
};
export const addNewPaidSuccess = (patientId) => {
  return {
    type: FETCH_PATIENT_HISTORY,
    payload: { patientId }
  };
};
export const onUpdatePatient = (data) => {
  return {
    type: ON_UPDATE_PATIENT,
    payload: data
  };
};
export const updatePatientSuccess = (patient) => {
  return {
    type: ON_UPDATE_PATIENT_SUCCESS,
    payload: patient
  };
};
export const onDeletePayment = (data) => {
  return {
    type: ON_DELETE_PAYMENT,
    payload: data
  };
};
export const deletePaymentSuccess = (patientId) => {
  return {
    type: FETCH_PATIENT_HISTORY,
    payload: { patientId }
  }
}
export const onDeleteHistory = (data) => {
  return {
    type: DELETE_PATIENT_HISTORY,
    payload: data
  }
}
export const deleteHistorySuccess = (patientId) => {
  return {
    type: FETCH_PATIENT_HISTORY,
    payload: { patientId }
  }
}
export const onSaveNewInterventions = (data) => {
  return {
    type: ON_SAVE_NEW_INTERVENTIONS,
    payload: data
  }
}
export const showSavingInterventionsBtnLoader = () => {
  return {
    type: SHOW_SAVING_INTERVENTIONS_BTN_LOADER
  }
}
export const saveInterventionsSuccess = (data) => {
  return {
    type: SAVE_INTERVENTIONS_SUCCESS,
    payload: data
  }
}



// WEBPACK FOOTER //
// ./actions/SinglePatient.js